<script>
    import { createEventDispatcher, onMount, tick } from "svelte";
    import { HStack, VStack, Spacer } from "../component/layout";
    import { add, update as updateGame, deleteGame as del, loadGame } from "../games.js";
    import {
        Button,
        Label,
        Hamburger,
        Text,
        Choice,
        DateField,
        TextEditor,
        TimeField,
        Upload,
    } from "../component/widget";
    import {
        GAME_TYPE,
        ITEM_TYPE,
        GAME_MODE,
        ITEM_TYPE_LABEL,
        ITEM_RESPONSE,
        GAME_PROGRESS_MODE,
    } from "../dico.js";
    import { fromSQLDate } from "../date.js";

    export let game;
    export let wedding_guid;
    export let isOpened = false;

    let cell;

    let isAddItem = false;
    let isEditGame = false;

    let itemId = null;

    $: console.log(game);
    //$: console.log(items);

    let name = game.name;
    let code = game.code;
    let admin_code = game.admin_code;
    let gameType = game.type;
    let mode = game.mode;
    let progess_mode = game.progess_mode;
    let penalty = game.penalty;
    let desc = game.desc;
    let duration = game.duration;
    let time = fromSQLDate(game.start);
    let image = game.image;
    let startDate = time;
    let startTime = time;

    let dateChosen = time;
    let selectedDateFormatted = null;

    let current = null;
    let showError = false;
    let errorMessage = null;

    let title = null;
    let timeout = null;
    let order = null;
    let lastOrder = 0;
    let type = "I";
    let content = null;
    let response = "A";

    let gameHamburger = { display: false, opened: false };
    let hamburger;
    let items = [];

    $: if (type == 'Q' || type == 'L') {
        timeout = 30;
    } else {
        timeout = 0;
    }

    function cookHamburgers(items) {
        if (items) {
            let h = [];
            h.push({ display: false, opened: false });
            for (const i of items) {
                h.push({ display: false, opened: false });
            }
            hamburger = h;
        }
    }

    $: cookHamburgers(items);

    async function refresh(wedding_guid, game) {
        if (game) {
            items = await loadGame(wedding_guid, game.id);
            if (items.length > 0) {
                lastOrder = parseInt(items[items.length - 1].order || "0", 10);
            } else {
                lastOrder = 0;
            }
        }
    }

    $: refresh(wedding_guid, game);

    const dispatch = createEventDispatcher();

    const validate = (event) => {
        switch (event.target.name) {
            default:
                break;
        }
    };

    const submitItem = async () => {
        await add(
            wedding_guid,
            game.id,
            itemId,
            title,
            order,
            timeout,
            type,
            JSON.stringify(content),
            response
        );

        if (itemId == null && (type == 'Q' || type == 'L')) {
            
            let c = JSON.stringify(content);
            //console.log("content", c);

            let search = '\\n'+response+'- ';
            let i = c.indexOf(search);
            let s = '';
            if (i != -1) {
                s = c.substring(i+search.length);
                i = s.indexOf('\\n');
                if (s != -1) {
                    s = s.substring(0, i);
                } 
                s = ' : ' + s;
                //console.log(s);
            }

            await add(
                wedding_guid,
                game.id,
                null,
                "R " + title,
                order + 10,
                timeout,
                'F',
                '[{\"insert\":\"R\u00e9ponse ' + response + s + '\"},{\"attributes\":{\"header\":1},\"insert\":\"\\n\"}]',
                response
            );
        }

        isAddItem = false;
        items = await loadGame(wedding_guid, game.id);
        lastOrder = parseInt(items[items.length - 1].order || "0", 10);
    };

    const cancel = () => {
        isAddItem = false;
    };

    const cancelEdit = () => {
        isEditGame = false;
    };

    const delItem = async (item_id) => {
        try {
            await del(wedding_guid, undefined, item_id);
            items = await loadGame(wedding_guid, game.id);
        } catch (e) {
            console.log(e);
        }
    };

    const addItem = () => {
        title = null;
        order = lastOrder + 10;
        timeout = 0;
        type = "I";
        content = null;
        response = "A";
        itemId = null;
        isAddItem = true;
    };

    const editItem = (item_id, i) => {
        let item = items.find((i) => i.id == item_id);
        title = item.title;
        order = item.order;
        timeout = item.timeout;
        type = item.type;
        content = JSON.parse(item.content);
        response = item.response;
        itemId = item.id;
        isAddItem = true;
        hamburger[i].opened = false;
    };

    const editGame = (e) => {
        e.stopPropagation();
        isEditGame = true;
        gameHamburger.opened = false;
    };

    const submitGame = async () => {
        try {
            showError = false;
            errorMessage = null;

            let start = startDate;
            start.setHours(startTime.getHours());
            start.setMinutes(startTime.getMinutes());
            start.setSeconds(startTime.getSeconds());
            let timestamp = Math.round(start.getTime() / 1000);

            await updateGame(
                wedding_guid,
                game.id,
                name,
                gameType,
                desc,
                duration,
                timestamp,
                undefined,
                mode,
                image,
                progess_mode,
                penalty
            );

            isEditGame = false;
            game.name = name;
            game.type = gameType;
            game.desc = desc;
            game.duration = duration;
            game.penalty = penalty;
            game.start = start;
            game.mode = mode;
            game.progess_mode = progess_mode;
            game.image = image;
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    const deleteGame = async (e) => {
        e.stopPropagation();
        try {
            hamburger.opened = false;
            showError = false;
            errorMessage = null;
            await del(wedding_guid, game.id);
            dispatch("refresh");
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    const publishGame = async (e) => {
        e.stopPropagation();

        try {
            gameHamburger.opened = false;
            showError = false;
            errorMessage = null;

            await updateGame(
                wedding_guid,
                game.id,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                true,
                undefined,
                undefined
            );

            isEditGame = false;
            game.published = "1";
        } catch (e) {
            showError = true;
            errorMessage = e;
        }
    };

    let urlBase = window.location.protocol + "//" + window.location.hostname;

    const launchGame = (e) => {
        e.stopPropagation();
        gameHamburger.opened = false;
        window.open(
            `${urlBase}/#/champiz/${wedding_guid}/?admin&game=${game.id}&admin_code=${game.admin_code}`,
            `${game.name}`
        );
    };

    onMount(() => {
        if (isOpened) {
            cell.scrollIntoView();
        }
    });
</script>

<section
    bind:this={cell}
    class="game"
    class:opened={isOpened}
    on:mouseenter={() => {(gameHamburger.display = true); console.log("mouseenter");}}
    on:mouseleave={() => {(gameHamburger.display = false); console.log("mouseleave");}}>
    <Button action={() => (isOpened = !isOpened)}>
        <HStack grow alignment="center">
            <span class="game">
                <Label icon="puzzle-piece" noshrink text={game.name} h="auto" />
            </span>
            <span class="type">
                <Label text={game.type} color="inherit" />
            </span>

            {#if game.published === "1"}
                <span class="type">
                    <Label text={"Publié"} color="inherit" />
                </span>
            {/if}

            {#if !isOpened}
                <span class="count-game">
                    <Label text={`${items.length} questions`} icon="question-circle" />
                </span>
            {/if}
            <span class="code">
                <Label text={`${game.code} / ${game.admin_code}`} icon="lock" />
            </span>

            <Hamburger
                bind:open={gameHamburger.opened}
                display={gameHamburger.display}
                left={false}>
                <Button action={(e) => editGame(e)}>
                    <Label text="Editer" icon="edit" h="24px" />
                </Button>
                <Button action={(e) => publishGame(e)}>
                    <Label text="Publier" icon="times-circle" h="24px" />
                </Button>
                <Button action={(e) => launchGame(e)}>
                    <Label text="Lancer" icon="eye" h="24px" />
                </Button>
                <Button action={(e) => deleteGame(e)}>
                    <Label text="Supprimer" icon="times-circle" h="24px" />
                </Button>
            </Hamburger>
            <Spacer />
            <span>Joueur</span>
            <img src={`${urlBase}/api/qrcode/?id=${wedding_guid}&c=${code}&p=champiz`} alt="Lancer Champiz joueur" height="80" />
            <Spacer />
            <span>Maître du jeu</span>
            <img src={`${urlBase}/api/qrcode/?id=${wedding_guid}&c=${admin_code}&p=champiz`} alt="Lancer Champiz master" height="80" />
            <Spacer />

            {#if isOpened}
                <Label icon="chevron-up" h="48px" />
            {:else}
                <Label icon="chevron-down" h="48px" />
            {/if}
        </HStack>
    </Button>
    <ul class:opened={isOpened}>
        <VStack>
            {#each items as item, i (item.id)}
                <section
                    class="item"
                    on:mouseenter={() => (hamburger[i].display = true)}
                    on:mouseleave={() => (hamburger[i].display = false)}>
                    <HStack alignment="flex-start" grow>
                        <span class="title">
                            <Label text={item.title} nowrap size="18" icon="file-alt" />
                        </span>
                        <span class="label">
                            <Label
                                tooltip={ITEM_TYPE_LABEL[item.type]}
                                text={ITEM_TYPE_LABEL[item.type]} />
                        </span>

                        <Hamburger
                            bind:open={hamburger[i].opened}
                            display={hamburger[i].display}
                            left={false}>
                            <Button
                                action={() => {
                                    isAddItem = false;
                                    tick().then(() => editItem(item.id, i));
                                }}>
                                <Label text="Editer" icon="edit" h="24px" />
                            </Button>
                            <Button action={() => delItem(item.id)}>
                                <Label text="Supprimer" icon="times-circle" h="24px" />
                            </Button>
                        </Hamburger>
                        <Spacer />
                    </HStack>
                </section>
            {/each}
            {#if !isAddItem}
                <div class="actions">
                    <Button action={addItem}>
                        <Label text="Ajouter une question au jeu" icon="user-plus" h="48px" />
                    </Button>
                </div>
            {:else}
                <form
                    on:submit|preventDefault={submitItem}
                    on:invalid={validate}
                    on:changed={validate}
                    on:input={validate}>
                    <Text
                        id={"title"}
                        reset
                        required
                        bind:value={title}
                        icon="fas fa-puzzle-piece"
                        label="Titre"
                        placeholder="Titre de la question"
                        bind:current
                        textTransform={"capitalize"} />

                    <Choice
                        id={"type"}
                        label="Type"
                        bind:value={type}
                        bind:current
                        icon="fas fa-chess"
                        values={ITEM_TYPE} />

                    {#if type == "Q"}
                        <Choice
                            id={"response"}
                            label="Réponse"
                            bind:value={response}
                            bind:current
                            icon="fas fa-thumbs-up"
                            values={ITEM_RESPONSE} />
                    {:else if type == "L"}
                        <Text
                            id={"response"}
                            reset
                            required
                            bind:value={response}
                            icon="fas fa-thumbs-up"
                            label="Réponse"
                            placeholder="Réponse à la question"
                            bind:current />
                    {/if}

                    <Text
                        id={"order"}
                        type="number"
                        required
                        reset
                        bind:value={order}
                        icon="fas fa-sort-numeric-down"
                        label="Ordre"
                        placeholder="Ordre"
                        bind:current />

                    <Text
                        id={"timeout"}
                        type="number"
                        reset
                        bind:value={timeout}
                        icon="fas fa-user-clock"
                        label="Durée"
                        placeholder="Durée"
                        bind:current />

                    <TextEditor
                        id={"content"}
                        reset
                        required
                        bind:value={content}
                        icon="fas fa-file"
                        label="Contenu"
                        placeholder="Saisissez ici votre question"
                        bind:current />
                    <HStack>
                        <button class="cancel" type="button" on:click={cancel}>
                            <i class="fas fa-angle-double-up" />
                            <span>Annuler</span>
                        </button>
                        <button class="primary" type="submit">
                            <i class="fas fa-user-plus" />
                            <span>Modifier</span>
                        </button>
                        <Spacer />
                    </HStack>
                </form>
            {/if}
        </VStack>
    </ul>
</section>

{#if isEditGame}
    {#if showError}
        <div class="error">Une erreur s'est produite: {errorMessage}</div>
    {/if}
    <form
        on:submit|preventDefault={submitGame}
        on:invalid={validate}
        on:changed={validate}
        on:input={validate}>
        <Text
            id={"name"}
            reset
            required
            bind:value={name}
            icon="fas fa-puzzle-piece"
            label="Nom"
            placeholder="Titre du jeu"
            bind:current
            textTransform={"capitalize"} />

        <Choice
            id={"gameType"}
            label="Type"
            bind:value={gameType}
            bind:current
            icon="fas fa-users"
            values={GAME_TYPE} />

        <Choice
            id={"mode"}
            label="mode"
            bind:value={mode}
            bind:current
            icon="fas fa-chess"
            values={GAME_MODE} />

        <Choice
            id={"progess_mode"}
            label="progess_mode"
            bind:value={progess_mode}
            bind:current
            icon="fas fa-sync"
            values={GAME_PROGRESS_MODE} />

        <DateField
            id={"startDate"}
            required
            placeholder="Choisissez une date de début"
            bind:selectedDateFormatted
            bind:value={dateChosen}
            bind:selectedDate={startDate}
            label="Date"
            bind:current />

        <TimeField
            id={"startTime"}
            required
            bind:value={startTime}
            label="Heure"
            placeholder="Choisissez une heure de début"
            bind:current />

        <Text
            id={"duration"}
            type="number"
            reset
            bind:value={duration}
            icon="fas fa-user-clock"
            label="Durée"
            placeholder="Durée du jeu (en secondes)"
            bind:current />

        <Text
            id={"penalty"}
            type="number"
            required
            reset
            bind:value={penalty}
            icon="fas fa-history"
            label="Pénalité"
            placeholder="Pénalité (en secondes)"
            bind:current />

        <Upload
            id="image"
            reset
            type="image"
            height="64"
            bind:value={image}
            icon="fas fa-picture"
            placeholder="Choissisez une image"
            bind:current />

        <HStack>
            <button class="cancel" type="button" on:click={cancelEdit}>
                <i class="fas fa-angle-double-up" />
                <span>Annuler</span>
            </button>
            <button class="primary" type="submit">
                <i class="fas fa-user-plus" />
                <span>Modifier</span>
            </button>
            <Spacer />
        </HStack>
    </form>
{/if}

<style>
    section.game {
        border: 1px solid var(--primary-color);
        border-radius: 5px;
        padding-top: 5px;
        margin-bottom: 5px;
        height: 85px;
    }
    section.game.opened {
        height: auto;
    }

    section.game:nth-child(even) {
        background-color: #edf4f9;
    }

    section.item:hover {
        background-color: rgb(244, 245, 247);
        color: rgb(23, 43, 77);
    }

    span.title {
        line-height: 1em;
        border-radius: 15px;
        background-color: #b8c5d0;
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    span.type {
        line-height: 1em;
        border-radius: 15px;
        background-color: var(--primary-light-color);
        color: var(--on-primary-color);
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    span.label {
        line-height: 1em;
        border-radius: 15px;
        background-color: var(--primary-light-color);
        color: var(--on-primary-color);
        padding: 0.5em;
        margin-bottom: 5px;
        margin-right: 1em;
    }

    span.game > :global(article) {
        padding: 0.5em;
    }

    ul {
        list-style-type: none;
        margin: 0;
        transform: scaleY(0);
        transform-origin: 50% 0;
        transition: none;
    }

    ul.opened {
        transform: scaleY(1);
        transition: transform 0.5s ease-out;
    }

    form {
        margin-left: 5px;
    }
    button {
        margin-left: 1em;
    }
    div.error {
        color: var(--error-color);
        background-color: white;
        display: block;
        font-size: 12px;
        margin: auto;
        padding: 1em;
    }
</style>
